import type { Identifier } from "ra-core";
import type { Activity } from "../types";
/** API rows include empty relations; the presence of a key is not a project link. */
export function activityProjectId(activity: Activity): Identifier | undefined {
  return (
    activity.project_id ??
    activity.deal?.id ??
    activity.dealNote?.deal_id ??
    activity.taskActivity?.deal_id ??
    undefined
  );
}
